<fgb-banner [pageTitle]="'earn.page.title' | translate" />

<fgb-page-header [pageTitle]="'earn.page.title'" [showBalance]="false" [backButtonLink]="'/'" />

<div class="container">
  <fgbcl-earn-points></fgbcl-earn-points>
</div>
